import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enTranslations from './locales/en.json'
import deTranslations from './locales/de.json'

// TypeScript type safety für Übersetzungskeys
import './types'

// Validierung der Übersetzungen in Development
import { validateTranslations, getTranslationStats } from './validateTranslations'

const resources = {
  en: { translation: enTranslations },
  de: { translation: deTranslations },
}

// Check if debug mode is enabled
const isDebugMode = import.meta.env.VITE_DEBUG_MODE === 'true'

// HTML lang-Attribut mit der aktiven Sprache synchron halten (Screenreader-Aussprache, #1554).
// Vor init() registriert: init() löst das erste languageChanged schon selbst aus, ein späterer
// Listener verpasst es und index.html bliebe nach jedem Reload auf lang="en".
i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', i18n.resolvedLanguage ?? lng)
  }
})

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['en', 'de'],
    nonExplicitSupportedLngs: true,
    fallbackLng: 'en',

    // Debug-Modus nur bei aktiviertem DEBUG_MODE
    debug: isDebugMode,

    // Missing-Key-Handler nur bei aktiviertem DEBUG_MODE
    saveMissing: isDebugMode,
    missingKeyHandler: (lngs, _ns, key, _fallbackValue) => {
      if (isDebugMode) {
        // Gruppiere nach Namespace für bessere Übersicht
        const namespace = key.split('.')[0] || 'root';
        console.groupCollapsed(`🌍 Missing translation: ${key}`);
        console.log(`📁 Namespace: ${namespace}`);
        console.log(`🌐 Languages: ${lngs.join(', ')}`);
        console.log(`📝 Full key: ${key}`);
        console.groupEnd();
      }
    },

    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  })

// Event Listener für Settings-Updates - Sprache automatisch wechseln

// Event Listener für Settings-Updates (lokale Updates)

// Validiere Übersetzungen beim Start (nur bei aktiviertem Debug-Modus)
if (isDebugMode) {
  validateTranslations()

  // Globale Hilfsfunktion für die Console verfügbar machen
  // @ts-ignore
  window.checkTranslations = () => {
    console.clear();
    validateTranslations();
  };

  // @ts-ignore
  window.getTranslationStats = getTranslationStats;

  console.log('\n💡 Translation Tools available in console:');
  console.log('   - window.checkTranslations() - Re-run validation');
  console.log('   - window.getTranslationStats() - Get detailed stats\n');
}

export default i18n
